export const bytesToSize = bytes => {
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB']
  if (bytes === 0) return '0 Byte'
  const i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)))
  return `${Math.round(bytes / Math.pow(1024, i), 2)} ${sizes[i]}`
}

export const convertToBytes = mb => {
  return parseInt(mb) * 1024 * 1024
}

export const parseFile = (file, fileList, acceptedFileProperties) => {
  const fileSize = file.size
  const maximumFileSize = convertToBytes(acceptedFileProperties.maxFileSizeInMB)
  const isValidFileType = acceptedFileProperties.allowedFileTypes
    .split(',')
    .filter(type => file.name.toLowerCase().match(type))
    .pop()

  const isValidFileSize = fileSize <= maximumFileSize
  const [first] = fileList.filter(
    item => item.displayName.toLowerCase() === file.name.toLowerCase(),
  )

  if (first) {
    throw new UploadFileValidationError(`${file.name} already exists.`)
  }

  if (!isValidFileType) {
    throw new UploadFileValidationError(
      `${file.name} is not a valid file type (${acceptedFileProperties.allowedFileTypes})`,
    )
  }

  if (!isValidFileSize) {
    throw new UploadFileValidationError(
      `${file.name} exceeds maximum file size (${acceptedFileProperties.maxFileSizeInMB} mb)`,
    )
  }
}

class UploadFileValidationError extends Error {
  constructor(message) {
    super(message)
    this.name = 'UploadFileValidationError'
  }
}
